import React from 'react'

function CompanyHeader() {
  return (
    <div className="flex flex-col gap-1 w-full p-8 pb-4 mb-5">
      <h1 className="text-3xl font-semibold text-[#181d27]">
        Company & billing
      </h1>
      <p className="text-[16px] text-[#535862]">
        Monitor the credit screening status of employees.
      </p>
    </div>
  )
}

export default CompanyHeader
